import { createSvg } from '@r1-frontend/ui-react/components/svg/createSvg';

const Timer = (
    {
        strokeWidth = 1.5,
    },
): JSX.Element => {
    return (
        <g id={'guts'}>
            <path
                d='M18.8145 12.25C18.8145 17.08 14.8945 21 10.0645 21C5.23445 21 1.31445 17.08
                1.31445 12.25C1.31445 7.42 5.23445 3.5 10.0645 3.5C14.8945 3.5 18.8145 7.42 18.8145 12.25Z'
                strokeWidth={strokeWidth}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M10.0645 7V12'
                strokeWidth={strokeWidth}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M7.06445 1H13.0645'
                strokeWidth={strokeWidth}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </g>
    );
};

export default createSvg(
    Timer,
    'timer',
);
